import {h, Fragment} from "preact"
import { useState } from "preact/hooks"
import { useAppStateSelector } from "@nosto/preact"
import Sidebar from "./Sidebar"
import Toolbar from "./Toolbar"
import { GridProvider } from "./GridContext"

/**
 * ContentWrapper takes a function to render non-empty results in the content area.
 * On loading the Loader is used and for empty results the NoResults component is used.
 */
function ContentWrapper({ type, children }) {
    const { foundProducts, loading } = useAppStateSelector(state => ({
        foundProducts: state.response.products?.total > 0,
        loading: state.loading,
    }))
    const [filtersHidden, setFiltersHidden] = useState(false)

    const toggleFilters = () => {
        setFiltersHidden(prev => !prev)
    }

    return (
        <GridProvider>
            <div className={`w-full ${filtersHidden ? "hide-filters" : ""}`} data-nosto-element={type}>
                
                    <div className="toolbar-wrap flex justify-between items-center">
                        <button
                            className="ns-hide-filters-btn flex items-center gap-2 uppercase color-text border-b border-solid color-border-dark"
                            onClick={toggleFilters}
                            aria-label={filtersHidden ? "Show filters" : "Hide filters"}
                        >
                            {filtersHidden ? "Show Filters" : "Hide Filters"}
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                                <path d="M2.29639 7.50094V0.982422M13.7038 14.0195V11.575M2.29639 14.0195V10.7602M13.7038 8.31576V0.982422M8.00009 3.42687V0.982422M8.00009 14.0195V6.68613" stroke="#191919" stroke-width="1.25" stroke-linecap="round"/>
                                <path d="M2.29638 10.7593C3.1964 10.7593 3.92601 10.0296 3.92601 9.12963C3.92601 8.22961 3.1964 7.5 2.29638 7.5C1.39636 7.5 0.666748 8.22961 0.666748 9.12963C0.666748 10.0296 1.39636 10.7593 2.29638 10.7593Z" stroke="#191919" stroke-width="1.25" stroke-linecap="round"/>
                                <path d="M7.99999 6.68699C8.90001 6.68699 9.62962 5.95738 9.62962 5.05736C9.62962 4.15734 8.90001 3.42773 7.99999 3.42773C7.09997 3.42773 6.37036 4.15734 6.37036 5.05736C6.37036 5.95738 7.09997 6.68699 7.99999 6.68699Z" stroke="#191919" stroke-width="1.25" stroke-linecap="round"/>
                                <path d="M13.7038 11.5757C14.6039 11.5757 15.3335 10.8461 15.3335 9.94604C15.3335 9.04602 14.6039 8.31641 13.7038 8.31641C12.8038 8.31641 12.0742 9.04602 12.0742 9.94604C12.0742 10.8461 12.8038 11.5757 13.7038 11.5757Z" stroke="#191919" stroke-width="1.25" stroke-linecap="round"/>
                            </svg>
                        </button>
                        <Toolbar />
                    </div>
              
                <div className="content-wrap flex justify-between">
                     <Sidebar />
                    <div
                        className="ns-d-block ns-d-md-inline ns-w-100 ns-border-box ns-p-0"
                        style={{ position: loading ? "relative" : "initial" }}
                    >
                        {children({ loading, foundProducts })}
                    </div>
                </div>
            </div>
        </GridProvider>
    )
}

export function wrapContent(type, Component) {
    return () => <ContentWrapper type={type}>{Component}</ContentWrapper>
}